import React from 'react';
import {styled, Text, TextAppearance, Breakpoints} from '@vw-marketing/us-components';

export interface LineWrapperProps {
  label: string;
  variant?: boolean;
  children?: React.ReactNode;
}

const customLineTittleClass = 'customLineTitle';

const StyledMainWrapper: any = styled.div`
  width: 100%;
  @media (min-width: ${Breakpoints.b1280}px) {
    margin-top: 0px;
    padding-left: 0px;
  }

  ${`.${customLineTittleClass} {
    font-size: 13px;
    line-height: 1.54;

    @media (min-width: ${Breakpoints.b1280}px) {
      font-size: 16px;
      line-height: 1.25;
    }
  }`}
`;

const StyledLineWrapper: any = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(0, 30, 80);
  border-image: initial;
  transition: transform 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
`;

const StyledLineTitle: any = styled.div`
  position: absolute;
  top: 0px;
  left: ${(props) => props.theme.size.grid001};
  transform: translateY(-50%);
  background-color: rgb(255, 255, 255);
  opacity: 1;
  padding: 0px 16px;
  transition: opacity 0.3s cubic-bezier(0.14, 1.12, 0.67, 0.99) 0s;
`;

const StyledLineWrapperContent: any = styled.div`
  padding: 36px 20px;
  padding-bottom: 34px;
  width: 100%;
  @media (min-width: ${Breakpoints.b1280}px) {
    margin-top: 0px;
  }

  ${(props: LineWrapperProps) =>
    props.variant
      ? `padding: 48px 20px 32px 30px;

        @media (min-width: ${Breakpoints.b1280}px) {
          padding: 42px;
        }`
      : ''}
`;

const LineWrapper = (props: LineWrapperProps): JSX.Element => {
  const {variant} = props;

  return (
    <StyledMainWrapper className="line-wrapper-container">
      <StyledLineWrapper>
        <StyledLineTitle className="line-wrapper-container">
          <Text
            appearance={TextAppearance.headline200}
            bold
            className={variant ? customLineTittleClass : ''}
          >
            {props.label}
          </Text>
        </StyledLineTitle>
        <StyledLineWrapperContent variant={variant}>
          {props.children}
        </StyledLineWrapperContent>
      </StyledLineWrapper>
    </StyledMainWrapper>
  );
};

export default LineWrapper;
